export const setDayDate = (days: number, date: Date = new Date()): Date => new Date(date.setDate(date.getDate() + days));
